import { render, staticRenderFns } from "./HandoverTasks.vue?vue&type=template&id=3d65d712&scoped=true"
import script from "./HandoverTasks.vue?vue&type=script&lang=js"
export * from "./HandoverTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d65d712",
  null
  
)

export default component.exports